import { formatPeriodo } from "../equipe-obra.utils";
import type { ProfissionalIndisponivelDialogProps } from "./types-profissional-indisponivel-dialog";

export function useProfissionalIndisponivelDialog({ itens }: ProfissionalIndisponivelDialogProps) {
  return {
    linhas: itens.map((item) => ({
      chave: `${item.nova.id}-${item.indisponivel.inicio}-${item.indisponivel.fim}`,
      testId: `profissional-indisponivel-${item.usuarioId}`,
      profissional: item.profissional,
      periodoObra: formatPeriodo(item.nova),
      periodoIndisponivel: formatPeriodo(item.indisponivel),
    })),
  };
}
